export default "__VITE_ASSET__wn5Ce7je__"